import { type Meta } from '@air/analytics';

const META: Meta = {
  description: 'User clicked "Open in Air" to view content in the Air web app',
  name: 'opened_in_air',
  params: [
    {
      description: 'The board ID being viewed (if navigated into a board)',
      name: 'board_id',
      required: false,
      type: 'string',
    },
    {
      description: 'The clip/version ID being viewed (if an asset is open)',
      name: 'clip_id',
      required: false,
      type: 'string',
    },
    {
      description: 'The library ID being viewed (if navigated into a library)',
      name: 'library_id',
      required: false,
      type: 'string',
    },
  ],
};

export default META;
